import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './DataOne.css';
import NavBar from '../components/navigation/NavBar';
import { Link } from 'react-router-dom';

function DataOne() {
	const [data, setData] = useState([]);
	const [load, setLoad] = useState(true);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		const interval = setInterval(() => {
			setIsLoading((prevLoading) => !prevLoading);
		}, 1000);

		return () => {
			clearInterval(interval);
		};
	}, []);

	useEffect(() => {
		fetchData();
		window.scrollTo({ top: 0, behavior: 'smooth' });
	}, []);

	const fetchData = async () => {
		try {
			const response = await axios.get(
				'https://kanasudb.sannidiconstruction.in/webdata1_fetch.php'
			);
			setData(response.data.data);
			setLoad(false);
		} catch (error) {
			console.error('Error fetching data:', error);
		}
	};

	const handleStatusUpdate = async (id) => {
		try {
			const response = await axios.post(
				'https://kanasudb.sannidiconstruction.in/webdata1_update.php',
				{ id }
			);
			setLoad(true);
			if (response.data.status) {
				fetchData();
			}
		} catch (error) {
			console.error('Error updating status:', error);
		}
	};

	const activeData = data.filter((item) => item.status === 'active');
	const inactiveData = data.filter((item) => item.status !== 'active');

	return (
		<div className="data-container">
			<NavBar />
			<div style={{ display: 'flex', gap: 10, alignItems: 'baseline' }}>
				<h1>Data List One</h1>
				<Link
					style={{
						color: 'green',
						textDecorationLine: 'underline',
						cursor: 'pointer',
					}}
					to={'/data_two'}
				>
					Change
				</Link>
			</div>
			{load === true ? (
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						height: 300,
						opacity: isLoading ? 1 : 0.5,
						transition: 'opacity 0.5s ease',
						alignItems: 'center',
					}}
				>
					<p style={{ fontSize: 25 }}>Loading...</p>
					{isLoading === true ? <p style={{ fontSize: 25 }}>.</p> : null}
				</div>
			) : (
				<table className="data-table">
					<thead>
						<tr>
							<th>ID</th>
							<th>Name</th>
							<th>Email</th>
							<th>Number</th>
							<th>Status</th>
							<th>Date</th>
						</tr>
					</thead>
					<tbody>
						{activeData.map((item) => (
							<tr key={item.id}>
								<td>{item.id}</td>
								<td>{item.name}</td>
								<td>{item.email}</td>
								<td>{item.number}</td>
								<td>
									<button
										className="status-button-active"
										onClick={() => handleStatusUpdate(item.id)}
									>
										{item.status}
									</button>
								</td>
								<td>{item.date}</td>
							</tr>
						))}
						{inactiveData.map((item) => (
							<tr key={item.id}>
								<td>{item.id}</td>
								<td>{item.name}</td>
								<td>{item.email}</td>
								<td>{item.number}</td>
								<td>
									<button
										className="status-button-done"
										onClick={() => handleStatusUpdate(item.id)}
									>
										{item.status}
									</button>
								</td>
								<td>{item.date}</td>
							</tr>
						))}
					</tbody>
				</table>
			)}
		</div>
	);
}

export default DataOne;
